import { styled } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";

export const PageBox = styled((props: any) => <Box {...props} />)(
  ({ theme }) => ({
    marginLeft: theme.spacer_n,
    marginRight: theme.spacer_n,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginRight: 0
    }
  })
);

export const SmallTextTypo = styled(Typography)(({ theme }) => ({
  fontsize: "0.875rem",
  fontfamily: "OpenSans"
}));
export const LargeTextTypo = styled(Typography)(({ theme }) => ({
  fontWeight: "Bold",
  fontsize: "1rem",
  fontfamily: "OpenSans"
}));
export const ItemHeader = styled("div")({
  paddingTop: "3rem",
  paddingLeft: "2rem"
});
export const BottomBox = styled(Box)(({ theme }) => ({
  paddingTop: "3rem",
  marginRight: "1rem",
  marginLeft: "2rem",
  "& .MuiLink-root": {
    color: "rgb(50, 65, 190)",
    textDecorationColor: "rgb(50, 65, 190)"
  }
}));
